import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../appstate';
import {distinctUntilChanged, filter, map, Observable} from 'rxjs';
import {CurrentScorecard, ScorecardType} from './current-scorecard';
// import {PlainScorecard} from '../../data/scorecard';
import {PlainScoreCard} from '../../data/mygolf.data';
/**
 * Created by ashok on 11/05/17.
 */

@Injectable()
export class CurrentScorecardDataService {
    constructor(private store: Store<AppState>){}

    /**
     * Gets the observable on CurrentScorecard in the store
     * @returns {Observable<T>}
     */
    public getCurrentScorecard(): Observable<CurrentScorecard> {
        return this.store
                   .select((appState:any)=>appState.reducers.currentScorecard)
            .pipe(distinctUntilChanged())
            .pipe(filter(Boolean));;
    }

    public getTeetimeBooking(): Observable<any> {
        return this.store
                    .select((appState:any)=>appState.reducers.teetimeBooking)
                .pipe(distinctUntilChanged())
                .pipe(filter(Boolean));;
    }

    public currentScorecardType(): Observable<ScorecardType> {
        return this.store
                   .select((appState:any)=>appState.reducers.currentScorecard.scorecardType)
                   .pipe(distinctUntilChanged())
                   .pipe(filter(Boolean));;
    }
    public scorecard(): Observable<PlainScoreCard> {
        return this.store
                   .select((appState:any)=>appState.reducers.currentScorecard.scorecard)
                   .pipe(distinctUntilChanged())
                   .pipe(filter(Boolean));;
    }
    public clubName(): Observable<string> {
        return this.scorecard()
            .pipe(map(scorecard=>scorecard.clubName));
    }
    public noScoring(): Observable<boolean> {
        return this.store
            .select((appState:any)=>appState.reducers.currentScorecard.scorecardType)
            .pipe(distinctUntilChanged())
            .pipe(map((scorecardType: ScorecardType)=>scorecardType === ScorecardType.None));
    }
    public normalGameScoring(): Observable<boolean> {
        return this.store
                   .select((appState:any)=>appState.reducers.currentScorecard.scorecardType)
                   .pipe(distinctUntilChanged())
                   .pipe(map((scorecardType: ScorecardType)=>scorecardType === ScorecardType.NormalGame));
    }
    public competitionScoring(): Observable<boolean> {
        return this.store
                   .select((appState:any)=>appState.reducers.currentScorecard.scorecardType)
                   .pipe(distinctUntilChanged())
                   .pipe(map((scorecardType: ScorecardType)=>scorecardType === ScorecardType.Competition));
    }
}